// Angular
import { Component } from '@angular/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
	selector: 'cv-custom-date-cell',
	templateUrl: './custom-date-cell.component.html',
})
export class CustomDueDateCellComponent implements ICellRendererAngularComp {
	public cellValue: any;

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		if (params.value) {
			const [year, month, day] = params.value.split('-');
			this.cellValue = `${month}/${day}/${year}`;
		  }
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

}
